/**
 * Method to format a string with the given arguments.
 * @param {Date} date - The date to format.
 * @returns {string} Formatted date
 */
const dateFormat = (date) => {
  if (date) {

    const sections = date.split("-")

    const day = sections[2].length >= 2 ? sections[2].substring(0, 2) : sections[2]
    const month = sections[1].length >= 2 ? sections[1].substring(0, 2) : sections[1]
    const year = sections[0].length >= 4 ? sections[0].substring(0, 4) : sections[0]

    return `${day}/${month}/${year}`

  } else {
    return '-'
  }
}

const dateFormat1 = (date) => {
  if (date) {

    const sections = date.split("-")

    const day = sections[2].length >= 2 ? sections[2].substring(0, 2) : sections[2]
    const month = sections[1].length >= 2 ? sections[1].substring(0, 2) : sections[1]
    const year = sections[0].length >= 4 ? sections[0].substring(0, 4) : sections[0]

    return `${year}-${month}-${day}`

  } else {
    return '-'
  }
}

const dateFormat2 = (date) => {
  if (date) {

    const sections = date.split("-")

    const day = sections[2].length >= 2 ? sections[2].substring(0, 2) : sections[2]
    const month = sections[1].length >= 2 ? sections[1].substring(0, 2) : sections[1]
    const year = sections[0].length >= 4 ? sections[0].substring(0, 4) : sections[0]

    return `${month}/${year}`

  } else {
    return '-'
  }
}

const dateFormatYear = (date) => {
  if (date) {

    const sections = date.split("-")

    const day = sections[2].length >= 2 ? sections[2].substring(0, 2) : sections[2]
    const month = sections[1].length >= 2 ? sections[1].substring(0, 2) : sections[1]
    const year = sections[0].length >= 4 ? sections[0].substring(0, 4) : sections[0]

    return `${year}`

  } else {
    return '-'
  }
}

/**
 * Method to obtain only year, month and day of the date provided as parameter.
 * @param {Date} date Date to obtain data year, month and day
 * @returns {string} String of length 10 containing the date in yyyy/MM/dd format.
 */
const getDate = (date) => {
  if(date) {
    return date.slice(0, 10)
  } else {
    return null
  }
}

export {
  dateFormatYear,
  dateFormat,
  dateFormat2,
  dateFormat1,
  getDate
}